import { render } from "./AplicacaoInfo.vue?vue&type=template&id=4e2a531a&scoped=true"
import script from "./AplicacaoInfo.vue?vue&type=script&lang=js"
export * from "./AplicacaoInfo.vue?vue&type=script&lang=js"

import "./AplicacaoInfo.vue?vue&type=style&index=0&id=4e2a531a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e2a531a"]])

export default __exports__